import { render, staticRenderFns } from "./EnglishSubmit.vue?vue&type=template&id=78efc58a&scoped=true"
import script from "./EnglishSubmit.vue?vue&type=script&lang=js"
export * from "./EnglishSubmit.vue?vue&type=script&lang=js"
import style0 from "./EnglishSubmit.vue?vue&type=style&index=0&id=78efc58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78efc58a",
  null
  
)

export default component.exports